// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"d2529aeb","223":"011a3a28"}[chunkId] + ".chunk.css";
};